import { Alert } from "antd";
import type { ReactNode } from "react";
import { AdminPageShell } from "./AdminPageShell";
import { LedgerTableViewport } from "./LedgerTableViewport";

export function AdminListShell({
  title,
  description,
  toolbar,
  err,
  errorBanner,
  table,
}: {
  title: string;
  description: string;
  toolbar?: ReactNode;
  err: "forbidden" | "error" | null;
  /** 列表仍展示，仅顶部提示 */
  errorBanner?: boolean;
  /** 接收表体可滚动高度（传给 Table scroll.y） */
  table: (tableBodyMaxHeight: number) => ReactNode;
}) {
  if (err === "forbidden") {
    return (
      <AdminPageShell title={title} description={description}>
        <Alert type="error" showIcon message="无权限访问管理接口" />
      </AdminPageShell>
    );
  }
  return (
    <AdminPageShell fill title={title} description={description} toolbar={toolbar}>
      {err === "error" && errorBanner ? (
        <Alert type="error" showIcon message="加载失败，请检查网络与后端" style={{ marginBottom: 12 }} />
      ) : null}
      <LedgerTableViewport>{table}</LedgerTableViewport>
    </AdminPageShell>
  );
}
